// 
const URL = process.env.REACT_APP_SERVER_URL;
 // Add this line to check the value of URL
export default URL;
